import React from "react";
import Indicator from "../../Indicator";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { MenuItem, TextField } from "@material-ui/core";

class ListeInterRang extends React.Component {
  render() {
    const {
      indicateur,
      onChangeIndicator,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
    } = this.props;

    const listeInterRang = [
      {
        libelle: "1 inter-rang sur 9",
        value: "1_INTER_RANG_SUR_9",
      },
      {
        libelle: "1 inter-rang sur 7",
        value: "1_INTER_RANG_SUR_7",
      },
      {
        libelle: "1 inter-rang sur 7",
        value: "1_INTER_RANG_SUR_7",
      },
      {
        libelle: "1 inter-rang sur 6",
        value: "1_INTER_RANG_SUR_6",
      },
      {
        libelle: "1 inter-rang sur 6",
        value: "1_INTER_RANG_SUR_6",
      },
      {
        libelle: "1 inter-rang sur 5",
        value: "1_INTER_RANG_SUR_5",
      },
      {
        libelle: "1 inter-rang sur 4",
        value: "1_INTER_RANG_SUR_4",
      },
      {
        libelle: "1 inter-rang sur 3",
        value: "1_INTER_RANG_SUR_3",
      },
      {
        libelle: "2 inter-rang sur 5",
        value: "2_INTER_RANG_SUR_5",
      },
      {
        libelle: "1 inter-rang sur 2",
        value: "1_INTER_RANG_SUR_2",
      },
      {
        libelle: "3 inter-rang sur 5",
        value: "3_INTER_RANG_SUR_5",
      },
      {
        libelle: "2 inter-rang sur 3",
        value: "2_INTER_RANG_SUR_3",
      },
      {
        libelle: "3 inter-rang sur 4",
        value: "3_INTER_RANG_SUR_4",
      },
      {
        libelle: "4 inter-rang sur 5",
        value: "4_INTER_RANG_SUR_5",
      },
      {
        libelle: "Tous les inter-rangs",
        value: "TOUS_LES_INTER_RANGS",
      },
    ];

    const valueRendered = (
      <TextField
        fullWidth={false}
        InputProps={valueInputProps}
        select
        value={indicateur.valeur.value}
        style={{
          fontWeight: indicateur.afficherGras ? "bold" : "normal",
          width: "20rem",
        }}
        disabled={computedFields.includes(indicateur.codeNational)}
        onChange={(event) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: event.target.value } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
      >
        {listeInterRang.map((element) => (
          <MenuItem key={element.value} value={element.value}>
            {element.libelle}
          </MenuItem>
        ))}
      </TextField>
    );

    return (
      <Indicator indicateur={indicateur} onChange={onChangeIndicator}>
        {valueRendered}
      </Indicator>
    );
  }
}

export default compose(withTranslation())(ListeInterRang);
